import { Platform } from 'react-native';
import { MMKV } from 'react-native-mmkv';

const STORAGE_KEY_PREFIX = 'onboarding:checklist_assignment_dismissed';
const mobileStorage = Platform.OS === 'web'
  ? null
  : new MMKV({ id: 'onboarding-checklist-assignment' });

export const buildChecklistAssignmentOnboardingKey = (
  userId?: string | null,
  companyId?: string | null
): string => `${STORAGE_KEY_PREFIX}:${companyId || 'unknown-company'}:${userId || 'anonymous'}`;

export const readChecklistAssignmentOnboardingDismissed = (key: string): boolean => {
  try {
    if (Platform.OS === 'web') {
      return typeof window !== 'undefined' && window.localStorage?.getItem(key) === '1';
    }
    return mobileStorage?.getString(key) === '1';
  } catch {
    return false;
  }
};

export const persistChecklistAssignmentOnboardingDismissed = (key: string): void => {
  try {
    if (Platform.OS === 'web') {
      if (typeof window !== 'undefined') window.localStorage?.setItem(key, '1');
      return;
    }
    mobileStorage?.set(key, '1');
  } catch {
    // O card continua dispensado na sessão atual mesmo se o storage estiver indisponível.
  }
};
